const SITE_ROUTES = {
  getAllForCompany: 'sites',
}

export default SITE_ROUTES
